import * as echarts from 'echarts'
import * as d3 from 'd3'
import { param } from 'jquery'
import { tree } from 'd3'

const tableOption = {
  pie1: function (data, total) {
    var html = '<thead>'+
      '<tr>' +
      '<th>名称</th>' +
      '<th>数值</th>' +
      '<th>百分比</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td>' +
        '<td>' + parseFloat(parseInt(el.value) / total * 100).toFixed(2) + ' %' + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  pie2: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th>名称</th>' +
      '<th>数值</th>' +
      '<th>百分比</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td>' +
        '<td>' + parseFloat(parseInt(el.value) / total * 100).toFixed(2) + ' %' + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  bar1: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th style="width:50%;">名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  themeRiver1: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th style="width:50%;">名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  bar2: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th>名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  bar3: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th>名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  bar4: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th>名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  line1: function (data, total) {
    var t = []
    data.forEach(el => {
      t = el.dataTitle
    })
    var html = '<thead><tr>' +
      '<th>名称</th>' +
      '<th>维度</th>' +
      '<th>数值</th>' +
      '<th>总数</th>' +
      '</tr></thead><tbody>'

    data.forEach(el => {
      el.data.forEach((j,i) => {
        html += '<tr><td>' + el.name + '</td>' +
          '<td>' + el.dataTitle[i] + '</td>' +
          '<td>' + j + '</td>'+
        '<td>' + el.value + '</td></tr>'
      })
    })
    html += '</tbody>'
    return html
  },
  tree1: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th style="width:50%;">名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  tree2: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th style="width:50%;">名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  circle1: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th style="width:50%;">名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  },
  radar1: function (data, total) {
    var html = '<thead>' +
      '<tr>' +
      '<th style="width:50%;">名称</th>' +
      '<th>数值</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>'
    data.forEach(el => {
      html += '<tr>' +
        '<td>' + el.name + '</td>' +
        '<td>' + el.value + '</td></tr>'
    })
    html += '</tbody>'
    return html
  }
}
const chartsOption = {
  /**
   * 饼图1
   */
  pie1: function (fontSizebl, total, data) {
    var title = []
    data.forEach(i => {
      title.push(i.name)
    })
    var option = {
      tooltip: {
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        formatter: '{b}: {c} ({d}%)', 
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        }
      },
      title: {
        text: '总数量',
        subtext: '820',
        textAlign: 'center',
        x: '49%',
        y: '30%',
        textStyle: {
          fontSize: 10 * fontSizebl,
          fontWeight: 'normal',
          color: '#fff'
        },
        subtextStyle: {
          color: '#fff',
          fontSize: 14 * fontSizebl
        },
      },
      legend: {
        bottom: '0px',
        type: 'scroll',
        icon: 'circle',
        data: title,
        textStyle: {
          color: 'rgba(255, 255, 255,0.8)'
        },
        pageTextStyle: {
          color: '#fff'
        }
      },
      series: [{
        type: 'pie',
        radius: ['40%', '68%'],
        center: ['50%', '42%'],
        large: true,
        largeThreshold: 2000,
        label: {
          show: true,
          position: 'outside',
          formatter(param) {
            // correct the percentage
            return param.name;
          },
          color: 'rgba(255, 255, 255, .8)',
          fontSize: 12 * ((fontSizebl - 1) < 1 ? 1 : 2)
        },
        itemStyle: {
          normal: {
            color: function (colors) {
              var colorList = ['#0053FF', '#1844A0', '#376FE3', '#A0F998', '#21DF70', '#31ECFF', '#48BEF3', '#68D0FF', '#339DFF'];
              return colorList[colors.dataIndex];
            }
          },
        },
        labelLine: {
          normal: {
            length: 15 * ((fontSizebl - 1) < 1 ? 1 : 5.2),
            length2: 30 * ((fontSizebl - 1) < 1 ? 1 : 5.2),
            lineStyle: {
              width: 1
            }
          }
        },
        emphasis: {
          label: {
            show: true,
            color: '#fff',
            fontSize: 12 * ((fontSizebl - 1) < 1 ? 1.2 : 2.2)
          }
        },
        data: [
        ]
      },
      // 边框的设置
      {
        radius: ['52%', '35%'],
        center: ['50%', '42%'],
        type: 'pie',
        hoverAnimation: false,
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        labelLine: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        tooltip: {
          show: false
        },
        itemStyle: {
          normal: {
            color: 'rgba(0,0,0,0.18)'
          }
        },
        data: [{
          value: 1,
        }],
      }
      ]
    }
    option.title.subtext = total
    option.series[0].data = data
    return option
  },
  pie2: function (fontSizebl, total, data) {
    var option = {
      tooltip: {
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        // formatter: '{b}:{c}', //显示的内容
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        }
      },
      title: {
        text: '总数量',
        subtext: '820',
        textAlign: 'center',
        x: '49%',
        y: '40%',
        textStyle: {
          fontSize: 10 * fontSizebl,
          fontWeight: 'normal',
          color: '#fff'
        },
        subtextStyle: {
          color: '#fff',
          fontSize: 18 * fontSizebl
        },
      },
      legend: {
        right: '10%',
        orient: 'vertical',
        icon: 'circle',
        x: 'center',
        y: '90%',
        textStyle: {
          color: '#fff'
        }
      },
      series: [{
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '48%'],
        label: {
          show: true,
          position: 'outside',
          formatter(param) {
            // correct the percentage
            return param.name + '\n' + param.percent + '%';
          },
          color: '#B7BDBF',
          fontSize: 12 * ((fontSizebl - 1) < 1 ? 1 : 2)
        },
        labelLine: {
          normal: {
            length: 15,
            length2: 15,
            lineStyle: {
              width: 1
            }
          }
        },
        emphasis: {
          label: {
            show: true,
            color: '#fff',
            fontSize: 12 * ((fontSizebl - 1) < 1 ? 1.2 : 2.2)
          }
        },
        data: [
        ]
      },
      // 边框的设置
      {
        radius: ['52%', '40%'],
        center: ['50%', '48%'],
        type: 'pie',
        hoverAnimation: false,
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        labelLine: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        tooltip: {
          show: false
        },
        itemStyle: {
          normal: {
            color: 'rgba(0,0,0,0.18)'
          }
        },
        data: [{
          value: 1,
        }],
      }
      ]
    }
    option.title.subtext = total
    option.series[0].data = data
    return option
  },
  bar1: function (fontSizebl, total, data) {
    var t = []
    var d = []
    data.forEach((el, i) => {
      t.push(el.name)
      d.push(el.value)
    })
    return {
      // backgroundColor: "#061740",
      color: ['#FFE5B9', '#33CCCC', '#1EC5EA'],
      tooltip: {
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        // formatter: '{b}:{c}', //显示的内容
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        }
      },
      grid: {
        //图例位置
        left: '2%',
        right: '0%',
        top: '10%',
        bottom: '5%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data:t,
          axisLine: {
            show: true, //隐藏y轴
            color: "rgba(255, 255, 255, 0.15)",
            lineStyle: {
              color: 'rgba(255,255,255,.15)'
            }
          },
          axisTick: {
            alignWithLabel: true,
          },
          // x轴的字体样式
          axisLabel: {
            width: 70,
            overflow: 'truncate',
            show: true,
            margin: 14, //边距
            textStyle: {
              color: 'rgba(255, 255, 255,0.8)',
              fontSize: 12 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
            },
            interval: 0, //x轴文字不隐藏
            rotate: 35,
          }
        }
      ],
      yAxis: {
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(255, 255, 255, 0.15)",
            type: 'solid',
            dashOffset: 0
          },
        },
        axisLabel: {
          textStyle: {
            color: '#BDD8FB',  //更改坐标轴文字颜色
            fontSize: 12 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
          }
        }
      },
      series: [
        {
          name: '',
          type: 'pictorialBar', //pictorialBar 象形柱图
          symbolSize: [12 * ((fontSizebl - 1) < 1 ? 1 : 2.2), 6], //调整截面形状
          symbolOffset: [0, 0],
          z: 12,
          itemStyle: {
            normal: {
              color: 'rgba(1,246,215,1)'
            },
          },
          // 实现数字展示在柱状图
          label: {
            show: false,
            position: 'top',
            fontSize: 12,
            color: '#fff',
            offset: [0, -10],
            formatter: '{c}' //添加单位
          },
          data: d
        },
        {
          name: '',
          type: 'bar', //bar 柱状图
          barWidth: 12 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
          barGap: '0%',
          itemStyle: {
            normal: {
              color: 'rgba(1,246,215, 0.3)'
            },
          },
          data: d
        },
        {
          name: '',
          type: 'pictorialBar', //pictorialBar 象形柱图
          symbolSize: [12 * ((fontSizebl - 1) < 1 ? 1 : 2.2), 8], //调整截面形状
          symbolOffset: [0, -5],
          z: 12,
          symbolPosition: 'end', //图形的位置 'start'：图形边缘与柱子开始的地方内切。'end'：图形边缘与柱子结束的地方内切。'center'：图形在柱子里居中。
          itemStyle: {
            normal: {
              color: 'rgba(1,246,215, 1)',
            },
          },
          data: d
        }
      ]
    }
  },
  bar2: function (fontSizebl, total, data) {
    var t = []
    var d = [];
    data.forEach(el => {
      t.push(el.name)
      d.push(el.value)
    })

    var option = {
      tooltip: {
        show: true,
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        // formatter: '{b}:{c}', //显示的内容
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        }
      },
      grid: {
        //图例位置
        left: '2%',
        right: '5%',
        top: '5%',
        bottom: '5%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              fontSize: 12 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
              color: 'rgba(255, 255, 255,0.8)'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#DDD'
            }
          },
          splitLine: {
            lineStyle: {
              //type: 'dashed',
              color: 'rgba(255,255,255,0.15)'
            }
          }
        }
      ],
      yAxis: [{
        gridIndex: 0,
        interval: 0,
        data: t,
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2) + "px",
            color: "rgba(255, 255, 255,0.8)"
          },
          formatter: function (value) {
            let valueTxt = '';
            if (value.length > 5) {
              valueTxt = value.substring(0, 5) + '...';
            }
            else {
              valueTxt = value;
            }
            return valueTxt
          }
        },
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        }

      }],
      series: [{
        type: 'bar',
        xAxisIndex: 0,
        yAxisIndex: 0,
        barWidth: 8 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        itemStyle: {
          normal: {
            barBorderRadius: [0, 8, 8, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: '#018136'
            }, {
              offset: 0.8,
              color: '#21DF70'
            }], false)
          }
        },
        data: d
      },

      ]
    }
    return option
  },
  bar3: function (fontSizebl, total, data) {
    var t = []
    var d = []
    data.forEach(el => {
      t.push(el.name)
      d.push(el.value)
    })

    var option = {
      tooltip: {
        show: true,
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        // formatter: '{b}:{c}', //显示的内容
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        }
      },
      grid: {
        //图例位置
        left: '2%',
        right: '5%',
        top: '5%',
        bottom: '5%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              fontSize: 12 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
              color: 'rgba(255, 255, 255,0.8)'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#DDD'
            }
          },
          splitLine: {
            lineStyle: {
              //type: 'dashed',
              color: 'rgba(255,255,255,0.15)'
            }
          }
        }
      ],
      yAxis: [{
        gridIndex: 0,
        interval: 0,
        data: t,
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2) + "px",
            color: "rgba(255, 255, 255,0.8)"
          },
          formatter: function (value) {
            let valueTxt = '';
            if (value.length > 5) {
              valueTxt = value.substring(0, 5) + '...';
            }
            else {
              valueTxt = value;
            }
            return valueTxt
          }
        },
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        }

      }],
      series: [{
        type: 'bar',
        xAxisIndex: 0,
        yAxisIndex: 0,
        barWidth: 8 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        itemStyle: {
          normal: {
            barBorderRadius: [0, 8, 8, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: '#1B63CC'
            }, {
              offset: 0.8,
              color: '#03DFFC'
            }], false)
          }
        },
        data: d
      },

      ]
    }
    return option
  },
  bar4: function (fontSizebl, total, data) {
    var option = null
    var yLabel = []
    var yData = []
    data.forEach(el => {
      yLabel.push(el.name)
      yData.push(el.value)
    })

    let bgData = []
    for (let i in yData) {
      bgData.push(100)
    }
    option = {
      grid: {
        left: '5%',
        right: '5%',
        bottom: '0%',
        top: '5%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: "#FFF",
        },
        formatter: function (params) {
          return params[0].name + '<br/>' + params[0].value + ' <br/>'
        }
      },
      xAxis: {
        show: false,
        type: 'value'
      },
      yAxis: [{
        type: 'category',
        axisLabel: {
          show: true,
          margin: 15,
          textStyle: {
            color: 'rgba(255, 255, 255, .8)',
          },
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        data: yLabel
      }, {
        type: 'category',
        axisTick: 'none',
        axisLine: 'none',
        show: true,
        axisLabel: {
          textStyle: {
            color: 'rgba(255, 255, 255, .8)',
            fontSize: '12'
          },
        },
        data: yData
      }],
      series: [{
        name: '',
        type: 'bar',
        z: 23,
        itemStyle: {
          normal: {
            barBorderRadius: [30, 30, 30, 30],
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: '#0FF8E5'
            }, {
              offset: 1,
              color: '#0FF8E5'
            }]),
            shadowBlur: 0,
            shadowColor: '#D9F5FF'
          },
        },
        barWidth: 12,
        data: yData
      },
      {
        name: '',
        type: 'bar',
        barWidth: 12,
        barGap: '-100%',
        data: bgData,
        barMaxHeight: '10%',
        itemStyle: {
          normal: {
            color: () => new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#47C8FF77',
              },
              {
                offset: 0.1,
                color: '#47C8FF44',
              },
              {
                offset: 0.5,
                color: '#47C8FF00',
              },
              {
                offset: 0.5,
                color: '#47C8FF00',
              },
              {
                offset: 0.90,
                color: '#47C8FF44',
              },
              {
                offset: 1,
                color: '#47C8FF77',
              },
            ]),
            barBorderRadius: [30, 30, 30, 30],
          }
        },
      },
      {
        // 分隔
        type: "pictorialBar",
        itemStyle: {
          normal: {
            color: "#012555"
          }
        },
        symbolRepeat: "fixed",
        symbolMargin: 12,
        symbol: "rect",
        symbolClip: true,
        symbolSize: [2, 12],
        symbolPosition: "start",
        symbolOffset: [-6, 0],
        data: bgData,
        zlevel: 1,
        animationEasing: "elasticOut"
      },
      ]
    }
    return option
  },
  bar5: function (fontSizebl, total, data) {
    var color = ['rgba(144, 218, 245,0.8)', 'rgba(107, 186, 227,0.8)', 'rgba(86, 143, 198,0.8)', 'rgba(62, 100, 171,0.8)', 'rgba(5, 45, 165,0.8)']
    var code = []
    var xData = []
    var s = []
    var count = []
   
    for (var i in data[0]) {
      if (i != 'year') {
        code.push(i)
        s.push({
          "name": i,
          "type": "bar",
          "stack": "总量",
          "barMaxWidth": 35,
          "barGap": "10%",
          "itemStyle": {
            "normal": {
              "color": '',
              "label": {
                "show": false,
                "textStyle": {
                  "color": "#fff"
                },
                "position": "inside",
                formatter: function (p) {
                  return p.value > 0 ? (p.value) : '';
                }
              }
            }
          },
          "data": [],
        })
      }
    }
    for (var i = 0; i < data.length; i++) {
      var c = 0
      xData.push(data[i].year)
      for (var k = 0; k < Object.keys(data[i]).length; k++) {
        if (Object.keys(data[i])[k] != 'year') {
          s[k].data.push(data[i][Object.keys(data[i])[k]])
          s[k].itemStyle.normal.color = color[k]
          c += data[i][Object.keys(data[i])[k]]
        }
      }
      count.push(c)
    }
    //for (var i = 0; i < s.length; i++) {
    //  for (var k = 0; k < s[i].data.length; k++) {
    //    count[k] = count[k] + s[i].data[k]
    //  }
    //}

    s.push({
      "name": "总数",
      "type": "line",
      symbolSize: 10,
      symbol: 'circle',
      "itemStyle": {
        "normal": {
          "color": "rgba(252,230,48,0)",
          "barBorderRadius": 0,
          "label": {
            "show": true,
            "position": "top",
            formatter: function (p) {
              return p.value > 0 ? (p.value) : '';
            }
          }
        }
      },
      "data": count
    })
    var option = {
      "title": {
        "text": "",
        x: "4%",

        textStyle: {
          color: '#fff',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#90979c',
          fontSize: '16',

        },
      },
      "tooltip": {
        "trigger": "axis",
        "axisPointer": {
          "type": "shadow",
          textStyle: {
            color: "#fff"
          }

        },
      },
      "legend": {
        x: '0%',
        top: '1%',
        textStyle: {
          color: '#90979c',
        },
        "data": code
      },
      "grid": {
        "borderWidth": 0,
        "top": 40,
        left: 50,
        right:5,
        "bottom": 90,
        textStyle: {
          color: "#fff"
        }
      },
      "calculable": true,
      "xAxis": [{
        "type": "category",
        "axisLine": {
          lineStyle: {
            color: '#90979c'
          }
        },
        "splitLine": {
          "show": false
        },
        "axisTick": {
          "show": false
        },
        "splitArea": {
          "show": false
        },
        "axisLabel": {
          "interval": 0,

        },
        "data": xData,
      }],
      "yAxis": [{
        "type": "value",
        "splitLine": {
          "show": false
        },
        "axisLine": {
          lineStyle: {
            color: '#90979c'
          }
        },
        "axisTick": {
          "show": false
        },
        "axisLabel": {
          "interval": 0,

        },
        "splitArea": {
          "show": false
        },

      }],
      "dataZoom": [{
        "show": true,
        "height": 30,
        "xAxisIndex": [
          0
        ],
        bottom: 30,
        "start": 50,
        "end": 100,
        handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
        handleSize: '110%',
        handleStyle: {
          color: "#d3dee5",

        },
        textStyle: {
          color: "#fff"
        },
        borderColor: "#90979c"


      }, {
        "type": "inside",
        "show": true,
        "height": 15,
        "start": 1,
        "end": 35
      }],
      "series": s
    }
    return option
    //  , {
    //  "name": "总数",
    //  "type": "line",
    //  symbolSize: 10,
    //  symbol: 'circle',
    //  "itemStyle": {
    //    "normal": {
    //      "color": "rgba(252,230,48,1)",
    //      "barBorderRadius": 0,
    //      "label": {
    //        "show": true,
    //        "position": "top",
    //        formatter: function (p) {
    //          return p.value > 0 ? (p.value) : '';
    //        }
    //      }
    //    }
    //  },
    //  "data": [
    //    1036,
    //    3693,
    //    2962,
    //    3810,
    //    2519,
    //    1915,
    //    1748,
    //    4675,
    //    6209,
    //    4323,
    //    2865,
    //    4298
    //  ]
    //},
  },
  line1: function (fontSizebl, total, data) {
    var s = []
    var t = []
    data.forEach(el => {
      s.push({
        name: el.name,
        type: 'line',
        stack: '总量',
        symbol: 'circle',
        symbolSize: 6,
        itemStyle: {
          normal: {
            color: '#aecb56',
            lineStyle: {
              color: "#aecb56",
              width: 1
            },
            areaStyle: {
              //color: '#94C9EC'
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: 'rgba(254, 248, 81,0.01)'
              }, {
                offset: 1,
                color: 'rgba(252, 239, 40,0.6)'
              }]),
            }
          }
        },
        data: el.data
      })
      t = el.dataTitle
    })

    var option = {
      grid: {
        left: '2%',
        right: '5%',
        top: '10%',
        bottom: '5%',
        containLabel: true
      },
      tooltip: {
        show: true,
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        // formatter: '{b}:{c}', //显示的内容
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
        }
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: 'rgba(255, 255, 255,0.8)',
            fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#397cbc'
            }
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#195384'
            }
          },
          data: t
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '',
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: 'rgba(255, 255, 255,0.8)',
              fontSize: 10 * ((fontSizebl - 1) < 1 ? 1 : 2.2),
            }
          },
          axisLine: {
            lineStyle: {
              color: '#27b4c2'
            }
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#11366e'
            }
          }
        },
        {
          type: 'value',
          name: '',
          axisLabel: {
            textStyle: {
              color: '#186afe'
            }
          },
          axisTick: {
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#11366e'
            }
          }
        }
      ],
      series: s
    }
    return option
  },
  tree1: function (fontSizebl, total, data) {
    var option = {
      tooltip: {
        show: true,
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        // formatter: '{b}:{c}', //显示的内容
        backgroundColor: 'rgba(5,29,69,0.86)', //背景颜色（此时为默认色）
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10,
        }
      },
      series: [{
        type: 'tree',
        initialTreeDepth: -1,
        name: 'tree1',
        data: [data[0]],
        top: '5%',
        left: '18%',
        bottom: '2%',
        right: '10%',
        roam: true,
        label: {
          normal: {
            position: 'left',
            verticalAlign: 'middle',
            align: 'right',
            color: 'rgba(255, 255, 255, .8)'
          }
        },
        lineStyle: {
          color: '#23CEFD'
        },
        leaves: {
          label: {
            normal: {
              position: 'right',
              verticalAlign: 'middle',
              align: 'left',
            }
          },
          itemStyle: {
            normal: {
              color: '#00C8FF'
            }
          },
        },
        expandAndCollapse: true,
        animationDuration: 550,
        animationDurationUpdate: 750
      }]
    }
    return option
  },
  tree2: function (fontSizebl, total, data) {
    
    var option = {
      tooltip: {
        show: true,
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function (params) {
          return params.data.name.replace('(null)', '')
        },
        backgroundColor: 'rgba(5,29,69,0.86)', //背景颜色（此时为默认色）
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10,
        }
      },
      series: [
        {
          type: 'tree',
          data: [data],
          label: {
            normal: {
              verticalAlign: 'middle',
              color: 'rgba(255, 255, 255, .8)',
              formatter: function (params) {
                return params.data.name.replace('(null)','')
              }
            }
          },
          lineStyle: {
            color: '#23CEFD'
          },
          leaves: {
            label: {
              normal: {
                verticalAlign: 'middle',
              }
            },
            itemStyle: {
              normal: {
                color: '#00C8FF'
              }
            },
          },
          top: '28%',
          bottom: '28%',
          roam: true,
          layout: 'radial',
          symbol: 'emptyCircle',
          symbolSize: 7,
          initialTreeDepth: 3,
          animationDurationUpdate: 750
        }
      ]
    }
    return option
  },
  themeRiver1: function (fontSizebl, total, data) {
    var option = null
    var arr = []
    var title = []
    data.forEach(i => {
      arr.push([i.year, i.value, i.code])
      if (title.indexOf(i.code) < 0) {
        title.push(i.code)
      }
    })
    var c = ['rgba(144, 218, 245,0.8)', 'rgba(107, 186, 227,0.8)', 'rgba(86, 143, 198,0.8)', 'rgba(62, 100, 171,0.8)', 'rgba(5, 45, 165,0.8)']
    option = {
      tooltip: {
        show: true,
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        trigger: 'axis',
        textStyle: {
          color: '#fff',
        },
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: 'rgba(255,255,255,0.8)',
            width: 1,
            type: 'solid'
          }
        },
        //position: function (point, params, dom, rect, size) {
        //  // 固定在顶部
        //  return [point[0], '10%'];
        //},
        formatter: function (params) {
          var html = params[0].data[0] + '<br/>'
          params.forEach(i => {
            var value = ''
            data.forEach(j => {
              if (j.year === params[0].data[0] && j.code === i.data[2]) {
                value = j.name
              }
            })
            html += '<span style="display: block; width: 10px; height: 10px; background:' + c[title.indexOf(i.data[2])] + '; border-radius: 10px; float:left;margin-right:10px;margin-top:8px;">&nbsp;</span>' + i.data[2] + '： ' + i.data[1] + ' <br/>'
          })
          return html
        }
      },
      legend: {
        top: '0%',
        textStyle: {
          color: 'rgba(255,255,255,0.8)',
        },
        data: title,
        tooltip: {
          show: true,
          position: [0, '10%'],
          formatter: function (params) {
            var val = ''
            data.forEach(i => {
              if (params.name === i.code) {
                val = i.name
                return
              }
            })
            return '<div style="white-space: break-spaces;">' + val.replace(/\r\n/g, "<br>").replace(/\n/g, "<br>") + '</div>'
          }
        }
      },
      singleAxis: {
        top: '15%',
        left: '5%',
        bottom: '15%',
        right: '10%',
        "axisLine": {
          lineStyle: {
            color: '#999'
          }
        },
        axisTick: {},
        axisLabel: {},
        type: 'time',
        axisPointer: {
          animation: true,
          label: {
            show: true,
            formatter: function (params) {
              return params.seriesData[0].data[0]
            }
          }
        },
        splitLine: {

          show: true,
          lineStyle: {
            type: 'dashed',

            opacity: 0.5,
          }
        }
      },
      series: [{
        type: 'themeRiver',
        label: {
          normal: {
            show: false,
            position: 'left'
          }
        },
        itemStyle: {
          normal: {
            color: function (params) {
              return c[title.indexOf(params.data[2])]
            }
          },
          emphasis: {
            shadowBlur: 20,
            shadowColor: 'rgba(0, 0, 0, 0.8)'
          }
        },
        data: arr
      }]
    }
    return option
  },
  themeRiver2: function (fontSizebl, total, data) {
    var option = null
    var arr = []
    var title = []
    data.forEach(i => {
      arr.push([i.year, i.value, i.code])
      if (title.indexOf(i.code) < 0) {
        title.push(i.code)
      }
    })
    var c = ['rgba(144, 218, 245,0.8)', 'rgba(107, 186, 227,0.8)', 'rgba(86, 143, 198,0.8)', 'rgba(62, 100, 171,0.8)', 'rgba(5, 45, 165,0.8)']
    option = {
      tooltip: {
        show: true,
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        trigger: 'axis',
        textStyle: {
          color: '#fff',
        },
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: 'rgba(255,255,255,0.8)',
            width: 1,
            type: 'solid'
          }
        },
        //position: function (point, params, dom, rect, size) {
        //  // 固定在顶部
        //  return [point[0], '10%'];
        //},
        formatter: function (params) {
          var html = params[0].data[0] + '<br/>'
          params.forEach(i => {
            var value = ''
            data.forEach(j => {
              if (j.year === params[0].data[0] && j.code === i.data[2]) {
                value = j.name
              }
            })
            html += '<span style="display: block; width: 10px; height: 10px; background:' + c[title.indexOf(i.data[2])] + '; border-radius: 10px; float:left;margin-right:10px;margin-top:8px;">&nbsp;</span>' + i.data[2] + '： ' + i.data[1] + ' <br/>'
          })
          return html
        }
      },
      legend: {
        top: '0%',
        textStyle: {
          color: '#000',
        },
        data: title,
        tooltip: {
          show: true,
          position: [0, '10%'],
          formatter: function (params) {
            var val = ''
            data.forEach(i => {
              if (params.name === i.code) {
                val = i.name
                return
              }
            })
            return '<div style="white-space: break-spaces;">' + val.replace(/\r\n/g, "<br>").replace(/\n/g, "<br>") + '</div>'
          }
        }
      },
      singleAxis: {
        top: '15%',
        left: '0%',
        bottom: '15%',
        right: '0%',
        "axisLine": {
          lineStyle: {
            color: '#999'
          }
        },
        axisTick: {},
        axisLabel: {
          show: true,
          formatter: '{yyyy}',
          interval: 0
        },
        type: 'time',
        axisPointer: {
          animation: true,
          label: {
            show: true,
            formatter: function (params) {
              return params.seriesData[0].data[0]
            }
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            opacity: 0.5,
          }
        }
      },
      series: [{
        type: 'themeRiver',
        label: {
          normal: {
            show: false,
            position: 'left'
          }
        },
        itemStyle: {
          normal: {
            color: function (params) {
              return c[title.indexOf(params.data[2])]
            }
          },
          emphasis: {
            shadowBlur: 20,
            shadowColor: 'rgba(0, 0, 0, 0.8)'
          }
        },
        data: arr
      }]
    }
    return option
  },
  circle1: function (fontSizebl, total, data) {
    var stratify = d3.stratify().parentId(function (d) { return d.id.substring(0, d.id.lastIndexOf(".")); });

    var rawData = [
      {
        "id": "中国",
        "value": ""
      },
      {
        "id": "中国.南京",
        "value": "100"
      },
      {
        "id": "中国.天津",
        "value": "80"
      }]
    var d = []
    d.push({
      id: data[0].name,
      value: data[0].value
    })
    data.forEach((i, index) => {
      if (index > 0) {
        d.push({
          id: data[0].name + '.' + i.name,
          value: i.value
        })
        total = total + i.value
      }
    })
    d[0].value = total

    var root = stratify(d)
      .sum(function (d) {
        return d.value;
      })
      .sort(function (a, b) {
        return b.value - a.value;
      });
    var maxDepth = 0;
    var seriesData = root.descendants().map(function (node) {
      maxDepth = Math.max(maxDepth, node.depth);
      return [
        node.value,
        node.depth,
        node.id
      ];
    });
    var pieces = [];
    for (var i = 0; i <= maxDepth; i++) {
      pieces.push({ value: i, label: 'Level ' + i });
    }

    function renderItem(params, api) {
      var context = params.context;
      if (!context.layout) {

        d3.pack()
          .size([api.getWidth() - 2, api.getHeight() - 2])
          .padding(3)(root);

        context.layout = {};
        root.descendants().forEach(function (node) {
          context.layout[node.id] = {
            x: node.x,
            y: node.y,
            r: node.r,
            isLeaf: !node.children || !node.children.length
          };
        });
      }

      var nodePath = api.value(2);
      var itemLayout = context.layout[nodePath];

      var nodeName = '';
      var textFont = api.font({
        fontSize: 12,
        fontFamily: 'Arial'
      });

      if (itemLayout.isLeaf && itemLayout.r > 10) {
        nodeName = nodePath.slice(nodePath.lastIndexOf('.') + 1).split(/(?=[A-Z][^A-Z])/g).join('\n');
        nodeName = echarts.format.truncateText(nodeName, itemLayout.r, textFont, '.');
      }
      if (itemLayout.isLeaf) {
        return {
          type: 'circle',
          shape: {
            cx: itemLayout.x,
            cy: itemLayout.y,
            r: itemLayout.r
          },
          z2: api.value(1) * 2,
          style: api.style({
            text: nodeName,
            textFont: textFont,
            textPosition: 'inside',
            stroke: 'rgba(4, 176, 244,1)',
            lineWidth: 1
          }),
          styleEmphasis: api.style({
            text: nodeName,
            textPosition: 'inside',
            textFont: textFont,
            stroke: 'rgba(4, 176, 244,1)',
            lineWidth: 1
          })
        };
      }
      return {
        type: 'circle',
        shape: {
          cx: itemLayout.x,
          cy: itemLayout.y,
          r: itemLayout.r
        },
        z2: api.value(1) * 2,
        style: api.style({
          text: nodeName,
          textFont: textFont,
          textPosition: 'inside',
          stroke: 'rgba(4, 176, 244,1)',
          lineWidth:0
        }),
        styleEmphasis: api.style({
          text: nodeName,
          textPosition: 'inside',
          textFont: textFont,
          stroke: 'rgba(4, 176, 244,1)',
          lineWidth:0
        })
      };
    }

    var option = {
      xAxis: {
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitLine: { show: false }
      },
      yAxis: {
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitLine: { show: false }
      },
      tooltip: {
        show: true,
        //鼠标悬浮提示
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function (params) {
          var val = ''
          if (params.value[2].indexOf('.') > -1) {
            val = params.value[2].split('.')[1] + ': ' + params.value[0] + '件'
          }
          return val
        },
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        textStyle: {
          color: '#fff',
          fontSize: 10,
        }
      },
      visualMap: {
        show: false,
        type: 'piecewise',
        bottom: 0,
        pieces: pieces,
        dimension: 1,
        inRange: {
          color: ['transparent', 'rgba(4, 176, 244,.4)']
        }
      },
      series: {
        type: 'custom',
        renderItem: renderItem,
        label: {
          normal: {
            show: true,
            textStyle: {
              color: 'rgba(255, 255, 255, .8)'
            }
          }
        },
        encode: {
          tooltip: 0,
          itemName: 2
        },
        data: seriesData
      }
    }
    return option
  },
  radar1: function (fontSizebl, total, data) {
    var dq = []
    var dp = []
    var dmax = []
    var drop = 2
    var indicatorD = []
    var html = '<table style="line-height: 20px;" cellpadding="0" cellspacing="0"><thead><tr>' +
      '<th style="text-align: left;width:80px;color: #23CEFD;">评估类型</th>' +
      '<th style="text-align: left;width:60px;color: #23CEFD;">企业得分</th>' +
      '<th style="text-align: left;width:60px;color: #23CEFD;">平均分</th>' +
      '<th style="text-align: left;width:60px;color: #23CEFD;">最高分</th></thead><tbody>'
    data.forEach(i => {
      html += '<tr>' + '<td style="color:rgba(255, 255, 255,1);">' + i.name + '</td>' + '<td style="color:rgba(19, 173, 255, 1);">' + i.value + '</td>' + '<td style="color:rgba(245, 166, 35, 1);">' + i.average + '</td>' + '<td style="color:rgba(75, 255, 252,1);">' + i.max + '</td>' + '</tr>'
      dq.push(i.value)
      dp.push(i.average)
      dmax.push(i.max)
      indicatorD.push({
        name: i.name,
        max: 100
      })
    })
    html += '</tbody></table>'

    var option = {
      "normal": {
        "top": 200,
        "left": 300,
        "width": 500,
        "height": 300,
        "zIndex": 6,
        "backgroundColor": ""
      },
      "color": ["rgba(245, 166, 35, 1)", "rgba(19, 173, 255, 1)", 'rgba(75, 255, 252,1)'],
      "title": {
        "show": true,
        "text": "",
        "left": "40%",
        "top": "1%",
        "textStyle": {
          "fontSize": 18,
          "color": "#fff",
          "fontStyle": "normal",
          "fontWeight": "normal"
        }
      },
      "tooltip": {
        "show": true,
        "trigger": "item",
        position: ['25%', '-50%'],
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        formatter: function (params) {
          return html
        },
        textStyle: {
          color: '#fff',
          fontSize: 10,
        }
      },
      "legend": {
        "show": true,
        "icon": "circle",
        "left": "30%",
        "top": "90%",
        "orient": "horizontal",
        "textStyle": {
          "fontSize": 14,
          "color": "#fff"
        },
        "data": ["企业得分", "平均分", '最高得分']
      },
      "radar": {
        "center": ["50%", "50%"],
        "radius": "60%",
        "startAngle": 90,
        "splitNumber": 4,
        "shape": "circle",
        "splitArea": {
          "areaStyle": {
            "color": ["transparent"]
          }
        },
        name: {
          textStyle: {
            color: '#fff',
            fontSize: 12,
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontStyle: 'italic',
          },
        },
        "axisLabel": {
          "show": false,
          "fontSize": 18,
          "color": "#fff",
          "fontStyle": "normal",
          "fontWeight": "normal"
        },
        "axisLine": {
          "show": true,
          "lineStyle": {
            "color": "rgba(23, 129, 186,0.4)"//
          }
        },
        "splitLine": {
          "show": true,
          "lineStyle": {
            "color": "rgba(23, 129, 186,0.4)"//
          }
        },
        "indicator": indicatorD
      },
      "series": [{
        "name": "企业得分",
        "type": "radar",
        "symbol": "circle",
        "symbolSize": drop,
        "itemStyle": {
          "normal": {
            color: 'rgba(19, 173, 255, 1)',
            "borderColor": "rgba(19, 173, 255, 0.4)",
            "borderWidth": 2
          }
        },
        "areaStyle": {
          "normal": {
            "color": "rgba(19, 173, 255, 0.5)"
          }
        },
        "lineStyle": {
          "normal": {
            "color": "rgba(19, 173, 255, 1)",
            "width": 1,
            "type": "dashed"
          }
        },
        "data": [dq]
      }, {
        "name": "平均分",
        "type": "radar",
        "symbol": "circle",
        "symbolSize": drop,
        "itemStyle": {
          "normal": {
            color: 'rgba(245, 166, 35, 1)',
            "borderColor": "rgba(245, 166, 35, 0.4)",
            "borderWidth": 2
          }
        },
        "areaStyle": {
          "normal": {
            "color": "rgba(245, 166, 35, 0.5)"
          }
        },
        "lineStyle": {
          "normal": {
            "color": "rgba(245, 166, 35, 1)",
            "width": 1,
            "type": "dashed"
          }
        },
        "data": [dp]
      }, {
        "name": "最高得分",
        "type": "radar",
        "symbol": "circle",
        "symbolSize": drop,
        "itemStyle": {
          "normal": {
            color: 'rgba(75, 255, 252,1)',
            "borderColor": "rgba(75, 255, 252,.4)",
            "borderWidth": 2
          }
        },
        "areaStyle": {
          "normal": {
            "color": "rgba(75, 255, 252,.5)"
          }
        },
        "lineStyle": {
          "normal": {
            "color": "rgba(75, 255, 252,1)",
            "width": 1,
            "type": "dashed"
          }
        },
        "data": [
          dmax
        ]
      }]
    }
    return option
  },
  radar2: function (fontSizebl, total, data) {
    var dq = []
    var dp = []
    var dmax = []
    var drop = 2
    var indicatorD = []
    var html = '<table style="line-height: 20px;" cellpadding="0" cellspacing="0"><thead><tr>' +
      '<th style="text-align: left;width:80px;color: #23CEFD;">评估类型</th>' +
      '<th style="text-align: left;width:60px;color: #23CEFD;">企业得分</th>' +
      '<th style="text-align: left;width:60px;color: #23CEFD;">平均分</th>' +
      '<th style="text-align: left;width:60px;color: #23CEFD;">最高分</th></thead><tbody>'
    data.forEach(i => {
      html += '<tr>' + '<td style="color:rgba(255, 255, 255,1);">' + i.name + '</td>' + '<td style="color:rgba(19, 173, 255, 1);">' + i.value + '</td>' + '<td style="color:rgba(245, 166, 35, 1);">' + i.average + '</td>' + '<td style="color:rgba(75, 255, 252,1);">' + i.max + '</td>' + '</tr>'
      dq.push(i.value)
      dp.push(i.average)
      dmax.push(i.max)
      indicatorD.push({
        name: i.name,
        max: 100
      })
    })
    html += '</tbody></table>'

    var option = {
      "normal": {
        "top": 200,
        "left": 300,
        "width": 500,
        "height": 300,
        "zIndex": 6,
        "backgroundColor": ""
      },
      "color": ["rgba(245, 166, 35, 1)", "rgba(19, 173, 255, 1)", 'rgba(75, 255, 252,1)'],
      "title": {
        "show": true,
        "text": "",
        "left": "40%",
        "top": "1%",
        "textStyle": {
          "fontSize": 18,
          "color": "#fff",
          "fontStyle": "normal",
          "fontWeight": "normal"
        }
      },
      "tooltip": {
        "show": true,
        "trigger": "item",
        position: ['25%', '-50%'],
        backgroundColor: "rgba(5,29,69,0.86)",
        borderColor: "rgba(147, 235, 248, .8)",
        formatter: function (params) {
          return html
        },
        textStyle: {
          color: '#000',
          fontSize: 10,
        }
      },
      "legend": {
        "show": true,
        "icon": "circle",
        "left": "20%",
        "top": "90%",
        "orient": "horizontal",
        "textStyle": {
          "fontSize": 14,
          "color": "#000"
        },
        "data": ["企业得分", "平均分", '最高得分']
      },
      "radar": {
        "center": ["50%", "50%"],
        "radius": "60%",
        "startAngle": 90,
        "splitNumber": 4,
        "shape": "circle",
        "splitArea": {
          "areaStyle": {
            "color": ["transparent"]
          }
        },
        name: {
          textStyle: {
            color: '#000',
            fontSize: 12,
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontStyle: 'italic',
          },
        },
        "axisLabel": {
          "show": false,
          "fontSize": 18,
          "color": "#000",
          "fontStyle": "normal",
          "fontWeight": "normal"
        },
        "axisLine": {
          "show": true,
          "lineStyle": {
            "color": "rgba(23, 129, 186,0.4)"//
          }
        },
        "splitLine": {
          "show": true,
          "lineStyle": {
            "color": "rgba(23, 129, 186,0.4)"//
          }
        },
        "indicator": indicatorD
      },
      "series": [{
        "name": "企业得分",
        "type": "radar",
        "symbol": "circle",
        "symbolSize": drop,
        "itemStyle": {
          "normal": {
            color: 'rgba(19, 173, 255, 1)',
            "borderColor": "rgba(19, 173, 255, 0.4)",
            "borderWidth": 2
          }
        },
        "areaStyle": {
          "normal": {
            "color": "rgba(19, 173, 255, 0.5)"
          }
        },
        "lineStyle": {
          "normal": {
            "color": "rgba(19, 173, 255, 1)",
            "width": 1,
            "type": "dashed"
          }
        },
        "data": [dq]
      }, {
        "name": "平均分",
        "type": "radar",
        "symbol": "circle",
        "symbolSize": drop,
        "itemStyle": {
          "normal": {
            color: 'rgba(245, 166, 35, 1)',
            "borderColor": "rgba(245, 166, 35, 0.4)",
            "borderWidth": 2
          }
        },
        "areaStyle": {
          "normal": {
            "color": "rgba(245, 166, 35, 0.5)"
          }
        },
        "lineStyle": {
          "normal": {
            "color": "rgba(245, 166, 35, 1)",
            "width": 1,
            "type": "dashed"
          }
        },
        "data": [dp]
      }, {
        "name": "最高得分",
        "type": "radar",
        "symbol": "circle",
        "symbolSize": drop,
        "itemStyle": {
          "normal": {
            color: 'rgba(75, 255, 252,1)',
            "borderColor": "rgba(75, 255, 252,.4)",
            "borderWidth": 2
          }
        },
        "areaStyle": {
          "normal": {
            "color": "rgba(75, 255, 252,.5)"
          }
        },
        "lineStyle": {
          "normal": {
            "color": "rgba(75, 255, 252,1)",
            "width": 1,
            "type": "dashed"
          }
        },
        "data": [
          dmax
        ]
      }]
    }
    return option
  }
}

export default {
  chartsOption,
  tableOption
}



// WEBPACK FOOTER //
// ./src/components/common/zyc/echarts/config/optionConfig.js